import EditTable from "./EditTable";
import EditTableColumn from "./EditTableColumn";
import EditTableColumnGroup from './EditTableColumnGroup';
EditTable.displayName = "EditTable"
EditTable.Column = EditTableColumn;
EditTable.ColumnGroup = EditTableColumnGroup;
export default EditTable;
